import { Injectable } from '@angular/core';
import { UserAccountType } from '../models/user.model';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {

  private user: UserAccountType;

  constructor(
    private authenticationService: AuthService,
  ) {
    this.authenticationService.currentUser$.subscribe((user) => {
      this.user = user;
    });
  }

  hasPermission(permission: any): boolean {
    if (!this.user || !permission || permission.trim().length === 0)
      return false;

    return this.user.permissions.includes(permission);
  }

  hasAnyPermission(permissions: any[]): boolean {
    const hasAnyPermission = permissions.some(permission => this.hasPermission(permission));
    return hasAnyPermission;
  }

  hasAllPermission(permissions: any[]): boolean {
    const hasAllPermission = permissions.every(permission => this.hasPermission(permission));
    return hasAllPermission;
  }
}

